import Login from "./login";
// import LoginVR from "./VRNEW/login";
import 'bootstrap/dist/css/bootstrap.min.css';
sessionStorage.setItem('Apipathurl','https://trackhr.co.in/AudioComplaintLogger/')
function App() {
  return (
    <Login />
    // <LoginVR/>
  );
}

export default App;
